import { render, staticRenderFns } from "./ApiChart.vue?vue&type=template&id=25a68c59&scoped=true"
import script from "./ApiChart.vue?vue&type=script&lang=ts"
export * from "./ApiChart.vue?vue&type=script&lang=ts"
import style0 from "./ApiChart.vue?vue&type=style&index=0&id=25a68c59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a68c59",
  null
  
)

export default component.exports